// extracted by mini-css-extract-plugin
export default {"button":"MyStaff_button__s99YK"};